<template>
	<form @submit="onSubmit" id="RegisterForm" class="register">
		<div v-if="step < 8">
			<div class="text-center">
				<label v-if="step==6" class="d-block">کد اعتبار سنجی به شماره موبایل {{ mobile }} ارسال شد.</label>
			</div>
			<div v-if="step==1">
				<div class="col-12 mb-2 mt-3">
					<label>نوع کاربری خود را انتخاب کنید</label>
					<select class="form-select"
							v-model="customerRolID"
							data-label="نوع کاربری">
						<option value="1">حقیقی</option>
						<option value="2">حقوقی</option>
					</select>
				</div>
				<div class="col-12 mb-2">
					<label>کد/شناسه ملی</label>
					<input type="text"
						   inputmode="numeric"
						   class="form-control"
						   data-label="کد/شناسه ملی"
						   :data-role-Id="customerRolID"
						   data-validations='["required","nationalcode"]'
						   v-model="nationalCode" />
				</div>
				<div class="col-12 mb-2">
					<label>کد معرف</label>
					<input type="text"
						   inputmode="numeric"
						   class="form-control"
						   data-label="کد معرف"
						   data-validations='["number"]'
						   v-model="introducerCode" />
				</div>
			</div>
			<div v-if="step==2">
				<div class="col-12 mb-2">
					<label>نام و نام خانوادگی/شرکت</label>
					<input type="text"
						   class="form-control"
						   data-label="نام و نام خانوادگی/شرکت"
						   data-validations='["required"]'
						   v-model="fullName" />
				</div>
				<div class="col-12 mb-2">
					<label>شهر محل سکونت</label>
					<v-select v-model="cityID"
							  label="CityName"
							  :options="cities"
							  :clearable="false"
							  :reduce="(o) => o.CityID">
						<template v-slot:option="option">
							{{ option.CountryName }} > {{ option.ProvinceName }} > {{ option.CityName }}
						</template>
					</v-select>
				</div>
				<div class="col-12 mb-2">
					<label>کد پستی</label>
					<input type="text"
						   inputmode="numeric"
						   class="form-control"
						   data-label="کد پستی"
						   data-validations='["required","number"]'
						   v-model="postalCode" />
				</div>
				<div class="col-12 mb-2">
					<label>آدرس</label>
					<input type="text"
						   class="form-control"
						   data-label="آدرس"
						   data-validations='["required"]'
						   v-model="address" />
				</div>
			</div>
			<div v-if="step==3">
				<div class="col-12 mb-2">
					<label>شماره شبا</label>
					<input type="text"
						   class="form-control"
						   data-label="شماره شبا"
						   v-model="sheba" />
				</div>
			</div>
			<div v-if="step==4">
				<div class="col-12 mb-2">
					<label>شماره موبایل</label>
					<input type="text"
						   inputmode="numeric"
						   class="form-control"
						   data-label="شماره موبایل"
						   data-validations='["required","mobile"]'
						   v-model="mobile" />
				</div>
			</div>
			<div v-if="step==5">
				<div class="col-12 mb-2">
					<label>کلمه عبور</label>
					<input type="password" class="form-control"
						   v-model="password"
						   data-label="کلمه عبور"
						   data-validations='["required","password"]' />
				</div>
				<div class="col-12 mb-2">
					<label>تکرار کلمه عبور</label>
					<input type="password" class="form-control"
						   v-model="repeatPassword"
						   data-label="تکرار کلمه عبور"
						   data-validations='["required","password"]' />
				</div>
			</div>
			<div v-if="step==6">
				<div class="col-12 mb-2">
					<label>کد اعتبارسنجی</label>
					<input type="text"
						   inputmode="numeric"
						   class="form-control"
						   v-model="authCode"
						   data-label="کد اعتبارسنجی"
						   data-validations='["required","number"]' />
				</div>
			</div>

			<div class="alert alert-info mt-2 errors" v-if="duplicateNationalCode">
				<strong>ثبت نام کد ملی {{ nationalCode }} قبلا در سیستم انجام شده است!</strong>
				<p>می توانید وارد شوید و یا درصورتی که کلمه عبور خود را فراموش کرده اید می توانید از بخش "بازیابی کلمه عبور" کلمه عبور خود را بازیابی نمایید.</p>
				<div class="col-12 float-right">
					<div class="row">
						<button class="btn btn-light mt-2" type="button" @click="$emit('stateChanged', 'login')">
							<span>ورود</span>
						</button>
						<button class="btn btn-light mt-2" type="button" @click="$emit('stateChanged', 'forgot-password')">
							<span>بازیابی کلمه عبور</span>
						</button>
					</div>
				</div>
			</div>

			<div class="alert alert-warning m-0" v-if="warnings.length">
				<ul>
					<li v-for="warning in warnings">
						{{ $t(warning.type,{label:warning.label}) }}
					</li>
				</ul>
			</div>
			<div class="alert alert-danger m-0" v-if="errors.length">
				<ul>
					<li v-for="error in errors">
						{{ $t(error.type) }}
					</li>
				</ul>
			</div>
			<div class="col-12 pr-0 pl-0 mt-2 float-right">
				<div class="row">
					<div class="col-2 pe-0">
						<button class="btn  btn-back" type="button" @click="onPrev">
							بازگشت
						</button>
					</div>
					<div class="col-10">
						<button class="btn btn-continue-register" type="submit" v-bind:disabled="loading">
							<span v-if="!loading">ادامه</span>
							<span v-if="loading" class="spinner-border spinner-border-sm"></span>
						</button>
					</div>
				</div>
			</div>
		</div>
	</form>

</template>

<script>

	import store from "@/common/store";
	import utility from '@/plugins/utility';
	const db = new utility.db();

	import vSelect from 'vue-select'
	import 'vue-select/dist/vue-select.css';

	export default {

		components: {
			'v-select': vSelect
		},

		emits: ["stateChanged"],
		data()
		{
			return {
				step: 1,
				customer: {},
				warnings: [],
				errors: [],
				customerRolID: '1',
				cityID: '',
				cities: [],
				nationalCode: '',
				introducerCode:'',
				postalCode: '',
				address: '',
				sheba: '',
				fullName: '',
				mobile: '',
				password: '',
				repeatPassword: '',
				authCode: '',
				active: false,
				loading: false,
				duplicateNationalCode: false,
			}
		},

		methods: {

			gotoClub()
			{
				this.request('/api/Club/GetCustomerInfo', null, (response) =>
				{
					if (response)
					{
						store.customer = response
						const redirectPath = this.$route.query.redirect || "/club/dashboard";
						this.$router.push(redirectPath);
					}
					else
					{
						this.errors = [{ type: 'errors.server' }];
					}

				}, 'get');
			},

			onSubmit(evt)
			{
				var form = new utility.form('#RegisterForm');
				evt.preventDefault()
				this.warnings = form.errors();
				this.errors = [];

				if (this.step == 2 && this.cityID == '')
				{
					this.warnings.push({ type: 'validation.required', label: 'شهر محل سکونت', value: '' })
				}

				if (this.warnings.length == 0)
				{

					if (this.step == 1)
					{
						this.request('/api/CustomerAuth/CheckNationalCode', {
							NationalCode: this.nationalCode,
							CustomerRolID: this.customerRolID,
							ApiRequestType: 'SignUp'
						}, (response) =>
						{
							if (response.success)
							{
								if (response.meta.customer)
								{
									this.address = response.meta.customer.address;
									this.cityId = response.meta.customer.cityId;
									this.leftCharge = response.meta.customer.leftCharge;
									this.fullName = response.meta.customer.fullName;
									this.mobile = response.meta.customer.mobile;
									this.postalCode = response.meta.customer.postalCode;
								}

								if (response.meta.message == "Active Customer Found")
								{
									this.duplicateNationalCode = true;
								}
								else
								{

									this.request('/api/General/GetCities', null, (response) =>
									{
										if (response)
										{
											this.cities = response.cities;
											this.loading = false;
											this.step = 2;
										}
									}, 'get');
								}
							}
						})


					}

					else if (this.step == 4)
					{
						this.request('/api/CustomerAuth/CheckDuplicateMobile',
							{
								NationalCode: this.nationalCode,
								PersonnelCode: this.personnelCode,
								Mobile: this.mobile,
							},
							(response) =>
							{
								if (response.success)
								{
									this.step = 5;
								}
								else
								{
									this.warnings.push({ type: 'validation.duplicateMobile' })
								}
							})
					}

					else if (this.step == 5)
					{
						if (this.password == this.repeatPassword)
						{
							this.request('/api/CustomerAuth/SaveInformation',
								{
									CustomerRolID: this.customerRolID,
									NationalCode: this.nationalCode,
									FullName: this.fullName,
									Mobile: this.mobile,
									CityID: this.cityID,
									Sheba: this.sheba,
									PostalCode: this.postalCode,
									Address: this.address,
									AuthCode: this.authCode,
									PassWord: this.password,
									IntroducerCode: this.introducerCode
								},
								(response) =>
								{
									if (response.success)
									{
										this.step = 6;
									}
									else
									{
										if (response.meta.message == "duplicate")
										{
											this.errors.push({ type: 'errors.disable' })
										}
										else
										{
											this.errors.push({ type: 'errors.noAccess' })
										}
									}
								})
						}
						else
						{
							this.warnings.push({ type: 'validation.repeatPassword' })
						}
					}


					else if (this.step == 6)
					{
						this.request('/api/CustomerAuth/CheckAuthCode', { NationalCode: this.nationalCode, AuthCode: this.authCode }, (response) =>
						{
							if (response.success)
							{
								axios({
									method: 'post',
									url: '/login',
									headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
									data: 'username=' + this.nationalCode + '&password=' + this.password + '&grant_type=password&customer=1'
								})
									.then(response =>
									{
										this.loading = false;
										if (response.data !== undefined)
										{
											if (response.data.access_token !== undefined)
											{
												store.token = response.data
												if (this.rememberMe)
													db.insert('__t', response.data);

												axios.defaults.headers.common['Authorization'] =
													'Bearer ' + store.token.access_token;

												this.gotoClub()
												return;
											}
										}

										this.errors = [{ type: 'errors.server' }];
									})
									.catch(error =>
									{
										this.loading = false;
										this.errors = [{ type: 'errors.server' }];
									});

								return;
							}

							this.warnings = [{ type: 'validation.auth' }];
						})
					}

					else this.step += 1;
				}
			},

			request(url, data, succees, method)
			{
				this.loading = true;
				axios({
					method: method || 'post',
					url: url,
					data: data
				})
					.then(response =>
					{
						this.loading = false;
						succees(response.data)
					})
					.catch(error =>
					{
						this.errors = [{ type: 'errors.server' }];
						this.loading = false;
					});
			},


			onPrev()
			{
				this.errors = []
				if (this.step == 1)
				{
					this.$emit('stateChanged', 'login')

				} else
				{
					this.step -= 1
				}
			}
		}
	}

</script>

<style scoped>
	.register .btn-continue-register {
		height: 45px;
		color: #000;
		background-color: #ffc600;
		width: 100%;
		transition: all 0.5s;
		outline: none;
		-webkit-box-shadow: none;
		box-shadow: none;
		transition: all .5s;
	}

		.register .btn-continue-register:hover {
			background-color: #fff;
			box-shadow: 0px 0px 10px 0px #ddd;
			color: #ffc600;
			transition: all .5s;
		}

	.register .btn-back {
		color: #000;
		background-color: #fff;
		border: 1px solid #ddd;
		width: 100%;
		height: 45px;
		transition: all 0.5s;
		outline: none;
		-webkit-box-shadow: none;
		box-shadow: none;
	}

	.vs--single .vs__selected{
		background:#fff !important;
	}
</style>
